import { CardActionArea, CardContent, Typography, Card as _Card } from '@mui/material'
import DynamicIcon from '../DynamicIcon/DynamicIcon'
import './Card.css'

const Card = (props) => {
  return (
    <_Card variant="outlined" className='card-container'>
        <CardContent sx={{ height: 'auto' }}>
            <DynamicIcon size={24} isGlobal={false} idIcon={props.icon} name={props.icon} color={'#e8e7e7'} />
            <Typography variant="body1" component="p" className='card-title'>
                {props.labels.title}
            </Typography>
            <Typography variant="body2" color="text.secondary" className='card-description'>
                {props.labels.description}
            </Typography>
        </CardContent>
    </_Card>
  )
}

export default Card